module.exports = __webpack_public_path__ + "media/images/bg-main-58b8eb97fcb8f9457fc6eac447e0e06f.png";